import { ComposerPrimitive, ThreadPrimitive } from '@assistant-ui/react';
import { Send, Square } from 'lucide-react';

export function IvyComposer() {
  return (
    <div className="flex-shrink-0 border-t border-border-secondary bg-background px-4 py-3">
      <div className="max-w-3xl mx-auto">
        <ComposerPrimitive.Root className="relative flex items-end gap-2 rounded-xl border border-border bg-surface px-3 py-2 focus-within:border-foreground/20 focus-within:ring-1 focus-within:ring-foreground/10 transition-all">
          <ComposerPrimitive.Input
            autoFocus={typeof window !== 'undefined' && !window.matchMedia('(pointer: coarse)').matches}
            placeholder="Message Ivy... (type / for commands)"
            rows={1}
            className="flex-1 bg-transparent text-sm text-foreground placeholder:text-muted-foreground/50 resize-none outline-none min-h-[36px] max-h-[200px] py-1"
          />

          <ThreadPrimitive.If running={false}>
            <ComposerPrimitive.Send asChild>
              <button className="p-2 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 disabled:opacity-30 disabled:cursor-not-allowed transition-colors flex-shrink-0">
                <Send className="w-4 h-4" />
              </button>
            </ComposerPrimitive.Send>
          </ThreadPrimitive.If>

          <ThreadPrimitive.If running>
            <ComposerPrimitive.Cancel asChild>
              <button className="p-2 rounded-lg bg-destructive/10 text-destructive hover:bg-destructive/20 transition-colors flex-shrink-0">
                <Square className="w-4 h-4" />
              </button>
            </ComposerPrimitive.Cancel>
          </ThreadPrimitive.If>
        </ComposerPrimitive.Root>

        <div className="text-center mt-1.5">
          <span className="text-[10px] text-muted-foreground/40">
            Enter to send &middot; Shift+Enter for new line &middot; / for commands
          </span>
        </div>
      </div>
    </div>
  );
}
